export const ARTICLES = [
    {
        postId: "ai-learning-strategy-and-rag-my-2-cents",
        title: "Exploring AI Through RAG: A Hands-On Learning Journey",
        description: "A hands-on exploration of AI through Retrieval-Augmented Generation, where I document my journey of building a smart chatbot trained on my own data and explain RAG concepts in a simple, practical way.",
        reading_time_minutes: 7,
        featured: true
    },
    {
        postId: "safely-collect-user-feedback-with-cloudflare-workers",
        title: "Safely Collecting User Feedback with Cloudflare Workers + Slack",
        description: "Don’t expose API keys in frontend. Instead, use serverless functions (Cloudflare Workers) to safely handle user feedback and add a layer of security against bad actors.",
        reading_time_minutes: 7
    },
    {
        postId: "react-github-professional-portfolio-website",
        title: "Building Professional Portfolio Websites with React and GitHub",
        description: "I have documented how to use ReactJS, SCSS, and GitHub to quickly build and host your portfolio website.",
        reading_time_minutes: 7
    },
    {
        postId: "learnings-from-ai-assisted-development-in-brownfield-project",
        title: "Lessons from AI-Assisted Development in a Brownfield Project",
        description: "What happens when you hand a years-old codebase to AI? A hands-on experiment in refactoring legacy software while preserving its behavior, with practical lessons on where AI helps and where developer judgment still matters.",
        reading_time_minutes: 20
    }
];